export const Events = Object.freeze({
  VARIANT_SELECTED: 'scale:variant:selected',
  PRODUCT_ADDED: 'scale:product:added',
  MODAL_OPEN: 'scale:modal:open',
  MODAL_CLOSE: 'scale:modal:close',
  DRAWER_OPEN: 'scale:drawer:open',
  DRAWER_CLOSE: 'scale:drawer:close',
  TOAST: 'scale:toast',
  QUANTITY_BREAKS_UPDATED: 'scale:quantity-breaks:updated',
  BUNDLE_UPDATED: 'scale:bundle:updated',
  SUBSCRIPTION_UPDATED: 'scale:subscription:updated',
  FILTERS_UPDATED: 'scale:filters:updated',
});

export class VariantSelectedEvent extends Event {
  constructor(variant) {
    super(Events.VARIANT_SELECTED, { bubbles: true });
    this.variant = variant;
  }
}

export class ProductAddedEvent extends Event {
  constructor(product, quantity) {
    super(Events.PRODUCT_ADDED, { bubbles: true });
    this.product = product;
    this.quantity = quantity;
  }
}

export class ModalOpenEvent extends Event {
  constructor(id) {
    super(Events.MODAL_OPEN, { bubbles: true });
    this.modalId = id;
  }
}

export class ModalCloseEvent extends Event {
  constructor(id) {
    super(Events.MODAL_CLOSE, { bubbles: true });
    this.modalId = id;
  }
}

export class DrawerOpenEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_OPEN, { bubbles: true });
    this.drawerId = id;
  }
}

export class DrawerCloseEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_CLOSE, { bubbles: true });
    this.drawerId = id;
  }
}

export class ToastEvent extends Event {
  constructor(message, { type = 'info', duration = 4000 } = {}) {
    super(Events.TOAST, { bubbles: true });
    this.message = message;
    this.toastType = type;
    this.duration = duration;
  }
}

export class QuantityBreaksUpdatedEvent extends Event {
  constructor(variantId, breaks) {
    super(Events.QUANTITY_BREAKS_UPDATED, { bubbles: true });
    this.variantId = variantId;
    this.breaks = breaks;
  }
}

export class BundleUpdatedEvent extends Event {
  constructor() {
    super(Events.BUNDLE_UPDATED, { bubbles: true });
  }
}

export class SubscriptionUpdatedEvent extends Event {
  constructor(sellingPlan) {
    super(Events.SUBSCRIPTION_UPDATED, { bubbles: true });
    this.sellingPlan = sellingPlan;
  }
}

export class FiltersUpdatedEvent extends Event {
  constructor(url) {
    super(Events.FILTERS_UPDATED, { bubbles: true });
    this.url = url;
  }
}
